// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  pip: {
    name: 'pip',
    componentName: 'Pip',
    chunk: () =>
      import(
        /* webpackChunkName: "pip" */
        './pages/Pip'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Pip.js')).Pip
        : currentRouteName === 'pip'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Pip }))
          );
    },
    path: '/:context?/p/:slug?/:slug?/:omsId/*',
    channel: null,
  },
  pcp: {
    name: 'pcp',
    componentName: 'Pcp',
    chunk: () =>
      import(
        /* webpackChunkName: "pcp" */
        './pages/Pcp'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Pcp.js')).Pcp
        : currentRouteName === 'pcp'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Pcp }))
          );
    },
    path: '/:context?/countertops/configurator/:omsId',
    channel: null,
  },
  pcpItem: {
    name: 'pcpItem',
    componentName: 'PcpItem',
    chunk: () =>
      import(
        /* webpackChunkName: "pcp" */
        './pages/Pcp'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Pcp.js')).Pcp
        : currentRouteName === 'pcpItem'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Pcp }))
          );
    },
    path: '/:context?/countertops/configurator/:omsId/item/:itemId',
    channel: null,
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () =>
      import(
        /* webpackChunkName: "home" */
        './pages/Home'
      ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({ default: pageModule.Home }))
          );
    },
    path: '/:context?/',
    channel: null,
  },
});
